import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#1F2125",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M15 1.667 18.334 5M1.667 18.333l1.064-3.9c.07-.254.104-.381.157-.5q.07-.159.173-.299c.077-.105.17-.198.357-.385l8.61-8.61c.166-.166.248-.248.344-.28a.4.4 0 0 1 .257 0c.095.032.178.114.343.28l2.39 2.39c.165.165.248.247.279.342a.4.4 0 0 1 0 .258c-.031.095-.114.177-.279.342l-8.61 8.612c-.187.186-.28.28-.386.356a1.7 1.7 0 0 1-.299.173 3.5 3.5 0 0 1-.5.158z"
    }, null, -1)
  ]))]))
}
export default { render: render }